import { render, staticRenderFns } from "./PreviewForm20.vue?vue&type=template&id=1592e04f&scoped=true"
import script from "./PreviewForm20.vue?vue&type=script&lang=ts"
export * from "./PreviewForm20.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1592e04f",
  null
  
)

export default component.exports